module.exports = ".autocomplete__items__item:last-child{border-bottom:none}"